export const EmiPaymentTableHeader = () => {
  return [
    { field: 'sl_no', headerName: 'Sl No', width: 90 },
    { field: 'fee_type', headerName: 'Fee Type', width: 160, sortable: true },
    { field: 'student_country_code', headerName: 'Student Region', width: 230, sortable: true },
    { field: 'admn_no', headerName: 'Admission No', width: 170, sortable: true },
    { field: 'student_name', headerName: 'Student Name', width: 200, sortable: true },
    { field: 'course_name', headerName: 'Course Name', width: 160, sortable: true },
    { field: 'income_transaction_date', headerName: 'Transaction Date', width: 180, sortable: true },
    { field: 'income_amount', headerName: 'Amount', width: 150, sortable: true },
    { field: 'payment_account', headerName: 'Credited Account', width: 180, sortable: true },
    { field: 'payment_mode', headerName: 'Payment Mode', width: 200, sortable: true },
    {
      field: 'income_screenshot',
      headerName: 'Screen Shot',
      type: 'action',
      actionType: 'view',
      actionKey: 'viewScreenshot',
      width: 200,
      buttonName: 'View',
    },
    { field: 'income_remarks', headerName: 'Remarks', width: 250 },
    { field: 'income_timestamp', headerName: 'Time Stamp', width: 200, sortable: true },
    { field: 'added_by', headerName: 'Added By', width: 180, sortable: true },
    { field: 'cro_name', headerName: 'CRO Name', width: 180, sortable: true },
    { field: 'income_reflected_at_bank_date', headerName: 'Reflected At Bank On', width: 200, sortable: true },
  ];
};
